export const colors = {
  black: '#020202',
  darkCharcoal: '#303030',
  lightBlack: '#250025',
  white: '#FFFFFF',
  pink: '#F6009B',
  green: '#0FB51F',
  textGray: '#777777',
  lightGray: '#EBECF1',
  borderGray: '#E6E6E6',
  bodyBackground: '#F3F2F7',
  red: 'red',
  orange: '#FF851B',
  inputBgGray1: '#a6a6a6',
  samokatGray: '#f2f2f2',
};

export const modalCloseButtonStyles = {
  bg: 'white',
  _hover: {
    bg: 'white',
  },
  _focus: {border: 'none'},
  _active: {
    bg: 'white',
  },
};

export const modalMetroCloseButtonStyles = {
  bg: colors.lightGray,
  _hover: {
    bg: colors.inputBgGray1,
  },
  _focus: {border: 'none'},
  _active: {
    bg: 'white',
  },
};

export const pinkScrollBarStyles = {
  '::-webkit-scrollbar': {
    width: '5px',
    backgroundColor: 'white',
    cursor: 'pointer',
    borderRadius: '6px',
  },
  '::-webkit-scrollbar-thumb': {
    width: '2px',
    backgroundColor: colors.pink,
    borderRadius: '6px',
  },
};

export const hiddenScrollBarStyles = {
  '::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
};

export const hiddenHorizontalScroll = {
  '.provider-scroll-item': {
    _first: {
      pl: '0px',
    },
    _last: {
      pr: ['0px', '0px'],
    },
  },
  '.provider-scroll-item>div': {
    m: 0,
  },
  '.react-horizontal-scrolling-menu--scroll-container': {
    scrollbarWidth: 'none',
  },
  '.react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar': {
    display: 'none',
  },
};
